import { Image } from "@heroui/react";

const PartnerSector = () => {
	return (
		<section className="pb-14">
			<div className="container mx-auto max-w-7xl px-4 lg:px-0">
				<p className="text-center md:text-lg max-w-3xl mx-auto">
					The Cambodia Carbon Registry platform is a joint initiative developed
					by the Ministry of Environment (MoE) and the United Nations
					Development Programme (UNDP).
				</p>
				<div className="flex gap-8 sm:gap-12 mt-10 justify-center items-center">
					<span>
						<Image
							src="/rgc-logo-sm.png"
							alt="RGC Logo"
							className="max-h-[80px] sm:max-h-[130px]"
						/>
					</span>
					<span>
						<Image
							src="/moe-logo-sm.png"
							alt="MOE Logo"
							className="max-h-[80px] sm:max-h-[130px]"
						/>
					</span>
					<span>
						<Image
							radius="none"
							src="/undp-logo-sm.png"
							alt="UNDP Logo"
							className="max-h-[80px] sm:max-h-[130px]"
						/>
					</span>
				</div>
			</div>
		</section>
	);
};

export default PartnerSector;
